import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

interface AdminGuardProps {
  children: ReactNode;
}

/**
 * AdminGuard - Protects routes under /admin.
 * Allows full ADMIN users plus MATCHING_SUPPORT (who get a filtered set
 * of tabs — see AdminLayout). Must be used inside AuthGuard.
 */
export const AdminGuard = ({ children }: AdminGuardProps) => {
  const { hasAnyRole } = useAuthStore();

  if (!hasAnyRole('ADMIN', 'MATCHING_SUPPORT')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
